document
  .querySelectorAll(".accordions-wrapper > .single-accordion-item")
  .forEach((accordion) => {
    let toggleButton = accordion.querySelector(".accordion-header");

    toggleButton.addEventListener("click", function (e) {
      let data = accordion.querySelector(".accordion-data");

      if (accordion.classList.contains("active")) {
        accordion.classList.remove("active");
        if (data.style.maxHeight) {
          data.style.maxHeight = null;
        } else {
          data.style.maxHeight = data.scrollHeight + "px";
        }
      } else {
        accordion.classList.add("active");
        if (data.style.maxHeight) {
          data.style.maxHeight = null;
        } else {
          data.style.maxHeight = data.scrollHeight + "px";
        }
      }
    });
  });
